var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#333438"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6664 23.9853C24.5567 23.8948 24.4526 23.8033 24.3541 23.7108C23.4105 22.8243 22.9387 21.7234 22.9387 20.4081C22.9387 18.8068 23.3747 17.5629 24.2469 16.6765C25.119 15.79 26.3486 15.3468 27.9356 15.3468C29.6799 15.3468 31.0167 15.8758 31.946 16.9338C32.8753 17.9918 33.34 19.4859 33.34 21.416H37.2861C37.2861 19.6718 36.9001 18.0705 36.128 16.6121C35.3559 15.1538 34.255 14.0171 32.8253 13.2022C31.3956 12.3729 29.7657 11.9583 27.9356 11.9583C25.262 11.9583 23.0959 12.759 21.4374 14.3603C19.7932 15.9616 18.9711 17.999 18.9711 20.4724C18.9711 21.7736 19.208 22.9446 19.6817 23.9853H16.3333V27.5539H32.249C31.2429 27.0215 30.0696 26.534 28.7291 26.0913C26.962 25.4638 25.6077 24.7618 24.6664 23.9853Z",
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7534 33.0442C33.1445 33.7673 33.3401 34.6594 33.3401 35.7206C33.3401 37.2505 32.904 38.4586 32.0319 39.345C31.1597 40.2315 29.8587 40.6747 28.1287 40.6747C26.27 40.6747 24.7974 40.1385 23.7108 39.0662C22.6385 37.9939 22.1023 36.4927 22.1023 34.5625H18.1562C18.1562 36.4212 18.5923 38.0726 19.4645 39.5166C20.3509 40.9463 21.559 42.0615 23.0889 42.8622C24.633 43.6485 26.3129 44.0417 28.1287 44.0417C30.9596 44.0417 33.1971 43.284 34.8413 41.7684C36.4855 40.2386 37.3076 38.2084 37.3076 35.6777C37.3076 34.7284 37.2038 33.8506 36.9961 33.0442H39.6667V29.4755H26.8531C27.0657 29.556 27.2836 29.636 27.5068 29.7157C29.7086 30.5021 31.2312 31.3099 32.0748 32.1391C32.3439 32.4037 32.5701 32.7054 32.7534 33.0442Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreetLogo);
export default __webpack_public_path__ + "static/media/street-logo.a0358bba947286ee2176d464c08e1e12.svg";
export { ForwardRef as ReactComponent };